import { Maybe } from '@iss/libs/graphql';

import { timeoutPassed } from './time';

import { AsyncData, AsyncStatus } from '@iss/wo-common/types';

export function assertNotNullable<T>(maybe: T): asserts maybe is NonNullable<T> {
  if (maybe == null) throw new Error(`${ String(maybe) } is null or undefined!`);
}

export function assertHasAsyncData<T>(data: AsyncData<T>): asserts data is { status: AsyncStatus.SUCCESS; data: T } {
  if (data.status !== AsyncStatus.SUCCESS) {
    throw new Error(`Assertion Failed! Required: ${AsyncStatus.SUCCESS}. Actual: ${data.status}`);
  }
}

const isNetworkError = (err: unknown): err is NetworkError =>
  err != null && typeof err === 'object' && ('status' in err || 'statusCode' in err);

const isApolloError = (err: unknown): err is ApolloError =>
  err != null && typeof err === 'object' && 'networkError' in err && isNetworkError(err.networkError);

type ApolloError = Readonly<{
  networkError: NetworkError;
}>;

type NetworkError = Readonly<{
  status?: number;
  statusCode?: number;
}>;

export const httpCode = (err?: unknown): number | undefined => {
  const networkError = isApolloError(err) ? err.networkError : isNetworkError(err) ? err : undefined;
  return networkError?.status || networkError?.statusCode;
};

export const isStatus = (code: number, err?: unknown): boolean => httpCode(err) === code;

export const is504 = (err?: unknown) => isStatus(504, err);
export const is451 = (err?: unknown) => isStatus(451, err);

export const isTimeout = (timestamp: Maybe<number>, err?: unknown) =>
  timeoutPassed(timestamp) || is504(err);
